// app.component.ts
import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { authCodeFlowConfig } from './core/auth/auth.config';
import { HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {

    constructor(private oauthService: OAuthService) {
        // Configure OAuth service here. This is the only setup needed in AppComponent.
        this.oauthService.configure(authCodeFlowConfig);
    }

  // ngOnInit(): void {
  //   this.detectDevTools();
  // }
  // @HostListener('document:contextmenu', ['$event'])
  // onRightClick(event: MouseEvent): void {
  //   event.preventDefault(); // Disable right-click
  // }

  // @HostListener('document:keydown', ['$event'])
  // onKeyDown(event: KeyboardEvent): void {
  //   // Block F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
  //   if (
  //     event.key === 'F12' ||
  //     (event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'J')) ||
  //     (event.ctrlKey && event.key === 'U')
  //   ) {
  //     event.preventDefault();
  //   }
  // }

  // detectDevTools(): void {
  //   const threshold = 160;
  //   setInterval(() => {
  //     const widthThreshold = window.outerWidth - window.innerWidth > threshold;
  //     const heightThreshold = window.outerHeight - window.innerHeight > threshold;

  //     if (widthThreshold || heightThreshold) {
  //       document.body.innerHTML = '<h1>DevTools Detected. Access Blocked.</h1>';
  //     }
  //   }, 1000);
  // }
}
